import React from "react";
import { Skeleton, Box } from "@mui/material";
import { ReactComponent as BACKBUTTON } from "../../../../assets/images/backbutton.svg";
import "./style.css";

function ProfileSettingsUnifiedSkeleton({
  showProfileComponent = true,
  uRole = "admin",
  userId,
  uID,
}) {
  console.log("Deploying User Traffic");
  return (
    <>
      {showProfileComponent ? (
        // Default Layout (Single Column)
        <>
          {showProfileComponent && (
            <div className="EditBack-profile">
              <BACKBUTTON />
              <div>
                <Skeleton variant="text" width={100} height={24} />
              </div>
            </div>
          )}
          <div className="ActivePrifle-Container">
            {/* Profile Header */}
            <div className="Active-Profile-Main-Container">
              <div className="Active-Profile-Main">
                <div className="EDITGROUP-LOGO-MAIN">
                  <Skeleton variant="circular" width={56} height={56} />
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "4px",
                    }}
                  >
                    <Skeleton variant="text" width={120} height={24} />
                    <Skeleton variant="text" width={80} height={16} />
                  </div>
                </div>
              </div>
              <div className="Edit-Group-Main-Button">
                <Skeleton
                  variant="rectangular"
                  width={120}
                  height={40}
                  sx={{ borderRadius: 1 }}
                />
                <Skeleton
                  variant="rectangular"
                  width={80}
                  height={40}
                  sx={{ borderRadius: 1 }}
                />
              </div>
            </div>

            {/* Profile Information Form */}
            <div className="Edit-Profile-Section">
              <Skeleton variant="text" width={150} height={24} />
              <div className="Profile-Input-Container">
                <Box sx={{ width: "100%" }}>
                  <Skeleton
                    variant="text"
                    width={80}
                    height={16}
                    sx={{ mb: 1 }}
                  />
                  <Skeleton
                    variant="rectangular"
                    height={48}
                    sx={{ borderRadius: 1 }}
                  />
                </Box>
                <Box sx={{ width: "100%" }}>
                  <Skeleton
                    variant="text"
                    width={80}
                    height={16}
                    sx={{ mb: 1 }}
                  />
                  <Skeleton
                    variant="rectangular"
                    height={48}
                    sx={{ borderRadius: 1 }}
                  />
                </Box>
              </div>
              <div className="Profile-Input-Container01">
                <Box sx={{ width: "100%" }}>
                  <Skeleton
                    variant="text"
                    width={80}
                    height={16}
                    sx={{ mb: 1 }}
                  />
                  <Skeleton
                    variant="rectangular"
                    height={48}
                    sx={{ borderRadius: 1 }}
                  />
                </Box>
                <Box sx={{ width: "100%" }}>
                  <Skeleton
                    variant="text"
                    width={80}
                    height={16}
                    sx={{ mb: 1 }}
                  />
                  <Skeleton
                    variant="rectangular"
                    height={48}
                    sx={{ borderRadius: 1 }}
                  />
                </Box>
              </div>
              <br />
              <Box sx={{ width: "100%" }}>
                <Skeleton
                  variant="text"
                  width={80}
                  height={16}
                  sx={{ mb: 1 }}
                />
                <Skeleton
                  variant="rectangular"
                  height={48}
                  sx={{ borderRadius: 1 }}
                />
              </Box>
            </div>

            {/* Group Assignment Section */}
            {(uRole === "admin" || uRole === "admin_with_billing") && (
              <>
                <p className="Profile-Line-Bottom" />
                <div className="EditProfile-Section">
                  <Skeleton variant="text" width={200} height={24} />
                  <div className="Profile-Input-Container-Group">
                    <Box sx={{ width: "100%" }}>
                      <Skeleton
                        variant="text"
                        width={120}
                        height={16}
                        sx={{ mb: 1 }}
                      />
                      <Skeleton
                        variant="rectangular"
                        height={48}
                        sx={{ borderRadius: 1 }}
                      />
                    </Box>
                  </div>
                  <Skeleton
                    variant="rectangular"
                    height={60}
                    sx={{ borderRadius: 1, mt: 2 }}
                  />
                </div>
              </>
            )}

            {/* Agent Status Section */}
            <p className="Profile-Line-Bottom" />
            <div className="ProfileInformation-container">
              <Skeleton variant="text" width={200} height={24} />
              <br />
              <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
                <Skeleton
                  variant="rectangular"
                  height={40}
                  sx={{ borderRadius: 1 }}
                />
                <Skeleton
                  variant="rectangular"
                  height={40}
                  sx={{ borderRadius: 1 }}
                />
                <Skeleton
                  variant="rectangular"
                  height={40}
                  sx={{ borderRadius: 1 }}
                />
              </Box>
            </div>

            {/* Availability Settings */}
            <div className="ProfileInformation-container">
              <Skeleton
                variant="text"
                width={200}
                height={24}
                sx={{ width: "50%", margin: "0 auto 20px auto" }}
              />
              <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
                {[...Array(7)].map((_, index) => (
                  <Box
                    key={index}
                    sx={{ display: "flex", gap: 2, alignItems: "center" }}
                  >
                    <Skeleton variant="text" width={80} height={24} />
                    <Skeleton variant="rectangular" width={100} height={40} />
                    <Skeleton variant="text" width={20} height={24} />
                    <Skeleton variant="rectangular" width={100} height={40} />
                    <Skeleton variant="rectangular" width={60} height={32} />
                  </Box>
                ))}
              </Box>
            </div>

            {/* Role and Permissions for admin or admin_with_billing (not owner) */}
            {(uRole === "admin" ||
              (uRole === "admin_with_billing" && userId !== uID)) && (
              <>
                <p className="Profile-Line-Bottom" />
                <div className="ProfileInformation-container">
                  <Skeleton variant="text" width={200} height={24} />
                  <br />
                  <Skeleton
                    variant="rectangular"
                    height={40}
                    sx={{ borderRadius: 1 }}
                  />
                </div>
                <p className="Profile-Line-Bottom" />
                <div className="ProfileInformation-container">
                  <Skeleton variant="text" width={200} height={24} />
                  <br />
                  <Skeleton
                    variant="rectangular"
                    height={60}
                    sx={{ borderRadius: 1 }}
                  />
                </div>
              </>
            )}

            {/* Role and Permissions for owner (admin_with_billing and userId === uID) */}
            {uRole === "admin_with_billing" && userId === uID && (
              <>
                <p className="Profile-Line-Bottom" />
                <div className="ProfileInformation-container">
                  <Skeleton variant="text" width={200} height={24} />
                  <br />
                  <Skeleton variant="text" width="80%" height={16} />
                  <Skeleton
                    variant="rectangular"
                    width={152}
                    height={40}
                    sx={{ borderRadius: 1, mt: 2 }}
                  />
                </div>
                <p className="Profile-Line-Bottom" />
                <div className="ProfileInformation-container">
                  <Skeleton variant="text" width={200} height={24} />
                  <br />
                  <Skeleton
                    variant="rectangular"
                    height={60}
                    sx={{ borderRadius: 1 }}
                  />
                </div>
              </>
            )}

            {/* Suspend and Delete Agent */}
            {(uRole === "admin" ||
              (uRole === "admin_with_billing" && userId !== uID)) && (
              <>
                <p className="Profile-Line-Bottom" />
                <div className="ProfileInformation-container">
                  <Skeleton variant="text" width={200} height={24} />
                  <div className="Suspend-agent-container">
                    <Skeleton variant="text" width="80%" height={16} />
                    <Skeleton
                      variant="rectangular"
                      width={120}
                      height={40}
                      sx={{ borderRadius: 1, mt: 2 }}
                    />
                  </div>
                </div>
                <p className="Profile-Line-Bottom" />
                <div className="ProfileInformation-container">
                  <Skeleton variant="text" width={200} height={24} />
                  <div className="Suspend-agent-container">
                    <Skeleton variant="text" width="80%" height={16} />
                    <Skeleton
                      variant="rectangular"
                      width={120}
                      height={40}
                      sx={{ borderRadius: 1, mt: 2 }}
                    />
                  </div>
                </div>
              </>
            )}
          </div>
        </>
      ) : (
        // Two-Column Layout
        <div className="profile-main-container">
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              padding: "24px",
              paddingTop: "76px",
              paddingRight: "80px",
            }}
          >
            <div style={{ width: "329px" }}>
              <Skeleton
                variant="text"
                width={200}
                height={24}
                sx={{ mb: "8px" }}
              />
              <Skeleton variant="text" width="80%" height={16} />
            </div>

            <div style={{ width: "552px" }}>
              <div className="Active-Profile-Main">
                <div className="EDITGROUP-LOGO-MAIN">
                  <Skeleton variant="circular" width={56} height={56} />
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "4px",
                    }}
                  >
                    <Skeleton variant="text" width={120} height={24} />
                    <Skeleton variant="text" width={80} height={16} />
                  </div>
                </div>
                <Skeleton
                  variant="rectangular"
                  width={120}
                  height={40}
                  sx={{ borderRadius: 1 }}
                />
              </div>
              <div className="Edit-Group-Main-Button">
                <Skeleton
                  variant="rectangular"
                  width={0}
                  height={0}
                  sx={{ display: "none" }}
                />
              </div>

              <div>
                <div className="Profile-Input-Container">
                  <Box sx={{ width: "100%" }}>
                    <Skeleton
                      variant="text"
                      width={80}
                      height={16}
                      sx={{ mb: 1 }}
                    />
                    <Skeleton
                      variant="rectangular"
                      height={48}
                      sx={{ borderRadius: 1 }}
                    />
                  </Box>
                  <Box sx={{ width: "100%" }}>
                    <Skeleton
                      variant="text"
                      width={80}
                      height={16}
                      sx={{ mb: 1 }}
                    />
                    <Skeleton
                      variant="rectangular"
                      height={48}
                      sx={{ borderRadius: 1 }}
                    />
                  </Box>
                </div>
                <div className="Profile-Input-Container01">
                  <Box sx={{ width: "100%" }}>
                    <Skeleton
                      variant="text"
                      width={80}
                      height={16}
                      sx={{ mb: 1 }}
                    />
                    <Skeleton
                      variant="rectangular"
                      height={48}
                      sx={{ borderRadius: 1 }}
                    />
                  </Box>
                  <Box sx={{ width: "100%" }}>
                    <Skeleton
                      variant="text"
                      width={80}
                      height={16}
                      sx={{ mb: 1 }}
                    />
                    <Skeleton
                      variant="rectangular"
                      height={48}
                      sx={{ borderRadius: 1 }}
                    />
                  </Box>
                </div>
                <div
                  style={{ marginTop: "56px" }}
                  className="Addworking-button-container"
                >
                  <Skeleton
                    variant="rectangular"
                    width={80}
                    height={40}
                    sx={{ borderRadius: 1 }}
                  />
                  <Skeleton
                    variant="rectangular"
                    width={80}
                    height={40}
                    sx={{ borderRadius: 1 }}
                  />
                </div>
              </div>
            </div>
          </div>

          {(uRole === "admin" || uRole === "admin_with_billing") && (
            <>
              <p className="Profile-Line-Bottom" />
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                  padding: "24px",
                  paddingRight: "80px",
                }}
              >
                <div style={{ width: "329px" }} />
                <div style={{ width: "552px" }}>
                  <Skeleton variant="text" width={200} height={24} />
                  <div className="Profile-Input-Container-Group">
                    <Box sx={{ width: "100%" }}>
                      <Skeleton
                        variant="rectangular"
                        height={48}
                        sx={{ borderRadius: 1 }}
                      />
                    </Box>
                  </div>
                  <Skeleton
                    variant="rectangular"
                    height={60}
                    sx={{ borderRadius: 1, mt: 2 }}
                  />
                </div>
              </div>
            </>
          )}

          <p className="Profile-Line-Bottom" />
          <div>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                padding: "24px",
                paddingRight: "80px",
              }}
            >
              <div style={{ width: "329px" }} />
              <div
                style={{
                  width: "552px",
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <Skeleton variant="text" width={200} height={24} />
                <br />
                <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
                  <Skeleton
                    variant="rectangular"
                    height={40}
                    sx={{ borderRadius: 1 }}
                  />
                  <Skeleton
                    variant="rectangular"
                    height={40}
                    sx={{ borderRadius: 1 }}
                  />
                  <Skeleton
                    variant="rectangular"
                    height={40}
                    sx={{ borderRadius: 1 }}
                  />
                </Box>
                <div>
                  <Skeleton
                    variant="text"
                    width={200}
                    height={24}
                    sx={{ mt: 2 }}
                  />
                  <Box
                    sx={{ display: "flex", flexDirection: "column", gap: 2 }}
                  >
                    {[...Array(7)].map((_, index) => (
                      <Box
                        key={index}
                        sx={{ display: "flex", gap: 2, alignItems: "center" }}
                      >
                        <Skeleton variant="text" width={80} height={24} />
                        <Skeleton
                          variant="rectangular"
                          width={100}
                          height={40}
                        />
                        <Skeleton variant="text" width={20} height={24} />
                        <Skeleton
                          variant="rectangular"
                          width={100}
                          height={40}
                        />
                        <Skeleton
                          variant="rectangular"
                          width={60}
                          height={32}
                        />
                      </Box>
                    ))}
                  </Box>
                </div>
              </div>
            </div>
          </div>

          {(uRole === "agent" || uRole === "admin") && (
            <>
              <p className="Profile-Line-Bottom" />
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                  padding: "24px",
                  paddingRight: "80px",
                }}
              >
                <div style={{ width: "329px" }} />
                <div style={{ width: "552px" }}>
                  <Skeleton variant="text" width={200} height={24} />
                  <br />
                  <Skeleton
                    variant="rectangular"
                    height={40}
                    sx={{ borderRadius: 1 }}
                  />
                </div>
              </div>
              <p className="Profile-Line-Bottom" />
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                  padding: "24px",
                  paddingRight: "80px",
                }}
              >
                <div style={{ width: "329px" }} />
                <div
                  style={{
                    width: "552px",
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  <Skeleton variant="text" width={200} height={24} />
                  <br />
                  <Skeleton
                    variant="rectangular"
                    height={60}
                    sx={{ borderRadius: 1 }}
                  />
                </div>
              </div>
            </>
          )}

          {uRole === "admin_with_billing" && (
            <>
              <p className="Profile-Line-Bottom" />
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                  padding: "24px",
                  paddingRight: "80px",
                }}
              >
                <div style={{ width: "329px" }} />
                <div style={{ width: "552px" }}>
                  <Skeleton variant="text" width={200} height={24} />
                  <br />
                  <Skeleton variant="text" width="80%" height={16} />
                  <Skeleton
                    variant="rectangular"
                    width={152}
                    height={40}
                    sx={{ borderRadius: 1, mt: 2 }}
                  />
                </div>
              </div>
              <p className="Profile-Line-Bottom" />
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                  padding: "24px",
                  paddingRight: "80px",
                }}
              >
                <div style={{ width: "329px" }} />
                <div
                  style={{
                    width: "552px",
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  <Skeleton variant="text" width={200} height={24} />
                  <br />
                  <Skeleton
                    variant="rectangular"
                    height={60}
                    sx={{ borderRadius: 1 }}
                  />
                </div>
              </div>
            </>
          )}

          {uRole === "agent" && (
            <>
              <p className="Profile-Line-Bottom" />
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                  padding: "24px",
                  paddingRight: "80px",
                }}
              >
                <div style={{ width: "329px" }} />
                <div style={{ width: "552px" }}>
                  <Skeleton variant="text" width={200} height={24} />
                  <div className="Suspend-agent-container">
                    <Skeleton variant="text" width="80%" height={16} />
                    <Skeleton
                      variant="rectangular"
                      width={120}
                      height={40}
                      sx={{ borderRadius: 1, mt: 2 }}
                    />
                  </div>
                </div>
              </div>
              <p className="Profile-Line-Bottom" />
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                  padding: "24px",
                  paddingRight: "80px",
                }}
              >
                <div style={{ width: "329px" }} />
                <div style={{ width: "552px" }}>
                  <Skeleton variant="text" width={200} height={24} />
                  <div className="Suspend-agent-container">
                    <Skeleton variant="text" width="80%" height={16} />
                    <Skeleton
                      variant="rectangular"
                      width={120}
                      height={40}
                      sx={{ borderRadius: 1, mt: 2 }}
                    />
                  </div>
                </div>
              </div>
            </>
          )}

          <br />
          <br />
        </div>
      )}
    </>
  );
}

export default ProfileSettingsUnifiedSkeleton;
